import React from 'react';
import { status } from '../data/siteContent';

/**
 * Closing band, where a marketing page would put its signup. There is nothing
 * to sign up for, so this states the position plainly instead.
 */
const StatusSection: React.FC = () => {
  return (
    <section id="status" className="band-night section-y">
      <div className="shell">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-gutter">
          <div className="lg:col-span-7">
            <p className="kicker text-primary-lift">{status.eyebrow}</p>
            <h2 className="display-lg mt-5 text-[2.25rem] text-white sm:text-[3.25rem]">
              {status.title}
            </h2>
            <p className="prose-reading mt-6 max-w-reading text-white/70">{status.body}</p>
            <p className="prose-note mt-5 max-w-reading border-l-2 border-primary-lift/50 pl-5 text-white/60">
              {status.note}
            </p>
          </div>

          <dl className="self-start lg:col-span-5">
            {status.facts.map((fact) => (
              <div key={fact.label} className="border-t border-white/15 py-4 first:border-t-0 first:pt-0">
                <dt className="kicker text-white/60">{fact.label}</dt>
                <dd className="mt-1.5 font-heading text-base text-white">{fact.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};

export default StatusSection;
